import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AuthService } from './auth.service';
import { HttpService } from './http.service';
import { EndpointsService } from './endpoints.service';
import { CartNotificationsController } from '../controllers/cart-notifications.controller';
import { PersonalizersService } from './personalizers.service';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  public shoppingCartId: any = 0;
  public receiptId?: any;

  private cartQuantity$: Subject<number> = new Subject();
  private inicializateCart$: Subject<boolean> = new Subject<boolean>();
  private isCardMethod$: Subject<boolean> = new Subject<boolean>();
  private isOpenModalMethod$: Subject<any> = new Subject<any>();
  private isOpenModalPay$: Subject<boolean> = new Subject<boolean>();
  private isOpenModalSuccess$: Subject<boolean> = new Subject<boolean>();
  private isOpenModalDenied$: Subject<boolean> = new Subject<boolean>();
  private isPaymentMethodComplete$: Subject<boolean> = new Subject<boolean>();
  private isPaymentMethodFinish$: Subject<boolean> = new Subject<boolean>();

  private cartBusinessPraga$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private appointmentDate$: BehaviorSubject<any> = new BehaviorSubject<any>({});
  private customerComments$: BehaviorSubject<string> = new BehaviorSubject<string>("");

  public addProductCart: boolean = false;
  public isConsultCard: boolean = false;

  public resultShoppingCart: any = [];

  private _cart = {
    products: <any>[],
  };
  public business?: any;

  get products() {
    return this._cart.products;
  }

  get productsCount() {
    var count = 0;
    this._cart.products.forEach((business: any) => {
      count += business.products.length;
    });
    return count;
  }

/*   private cartQuantitySubject = new BehaviorSubject<number>(Number(sessionStorage.getItem('cartQuantity') || 0));

  // Observable expuesto para que otros componentes se suscriban
  getCartQuantity$(): Observable<number> {
    return this.cartQuantitySubject.asObservable();
  } */

  constructor(
    private authService: AuthService,
    private personalizersService: PersonalizersService,
    private cartNotification: CartNotificationsController,
    private httpService: HttpService,
    private endpoints: EndpointsService
  ) { }

  closeAllModals() {
    this.isCardMethod$.next(false);
    this.isOpenModalMethod$.next(false);    
    this.isOpenModalPay$.next(false);
    this.isOpenModalSuccess$.next(false);
    this.isOpenModalDenied$.next(false);
    this.isPaymentMethodComplete$.next(false);
    this.isPaymentMethodFinish$.next(false);
  }

  getAppointmentDate$(): Observable<any> {
    return this.appointmentDate$.asObservable();
  }

  getCustomerComments$(): Observable<string> {
    return this.customerComments$.asObservable();
  }

  setCustomerComments(comment: string | null) {
    this.customerComments$.next((comment) ? comment : "");
  }

  getCartQuantity$(): Observable<number> {
    return this.cartQuantity$.asObservable();
  }

  getCardMethod$(): Observable<any> {
    return this.isCardMethod$.asObservable();
  }

  setCardMethod(flag: boolean) {
    return this.isCardMethod$.next(flag);
  }

  getCartBusinessPraga$(): Observable<any> {
    return this.cartBusinessPraga$.asObservable();
  }

  getInicializateCart$(): Observable<any> {
    return this.inicializateCart$.asObservable();
  }

  getOpenModalMethod$(): Observable<any> {
    return this.isOpenModalMethod$.asObservable();
  }

  setOpenModalMethod(flag: any) {
    this.isOpenModalMethod$.next(flag);
  }

  getOpenModalPay$(): Observable<any> {
    return this.isOpenModalPay$.asObservable();
  }

  setOpenModalPay(flag: boolean) {
    return this.isOpenModalPay$.next(flag);
  }

  setOpenModalDenied(flag: boolean) {
    this.isOpenModalDenied$.next(flag);
  }

  getOpenModalDenied$(): Observable<any> {
    return this.isOpenModalDenied$.asObservable();
  }

  setOpenModalSuccess(flag: boolean) {
    return this.isOpenModalSuccess$.next(flag);
  }

  getOpenModalSuccess$(): Observable<any> {
    return this.isOpenModalSuccess$.asObservable();
  }

  getPaymentMethodComplete$(): Observable<any> {
    return this.isPaymentMethodComplete$.asObservable();
  }

  setPaymentMethodComplete(flag: boolean) {
    return this.isPaymentMethodComplete$.next(flag);
  }

  getPaymentMethodFinish$(): Observable<any> {
    return this.isPaymentMethodFinish$.asObservable();
  }

  setPaymentMethodFinish(flag: boolean) {
    return this.isPaymentMethodFinish$.next(flag);
  }

  getShoppingCart(customerId: string): Observable<any> {
    return this.httpService.get(this.endpoints.shoppingCartForCustomer.replace('{id}', customerId));
  }
  

  emptyCart() {
    this._cart.products = [];
    // Notify cart quantity updated
    this.cartQuantity$.next(this.productsCount);

    this.inicializateCart$.next(true);
  }

  sendAppointmentDate(appointment: any) {
    this.appointmentDate$.next(appointment);
  }

  sendCartBusinessPraga$(businessPragaId: any) {
    this.cartBusinessPraga$.next(businessPragaId);
  }

  priceDiscountItem(product: any) {
    if (product?.discount?.type === 'percent') {
      let discountNumb = (100 - Number(product?.discount?.value)) / 100;
      return product.priceProduct * discountNumb;
    }

    if (product?.discount?.type === 'amount') {
      return product.priceProduct - Number(product?.discount?.value);
    }

    if (product?.discount?.type === 'product') {
      return product.priceProduct;
    }
    return '';
  }

  async addProduct(product: any, businessTheme: string, saleAppointment?: any) {
    //calculate discount
    let discountPrice = this.calculateDiscount(product.discounts?.type,
      product.discounts?.value, String(product.subTotal), product.quantity);

    if (this.isConsultCard) {
      // Check if the business is already in the cart
      let businessIndex = this._cart.products.findIndex((business: any) => {
        return business.id.toString() === product.businessId.toString()

      })

      if (businessIndex === -1) {
        // Add the business 
        this._cart.products.push({
          id: product.businessId,
          name: product.businessName,
          ownerId: product.ownerId,
          cartoptions: await this.setCartOptionsValue(product.businessId),
          products: [
            {
              id: product.id,
              name: product.name,
              description: product.description,
              comments: product.comments,
              price: product.price,
              quantity: product.quantity,
              dateRegister: product.dateRegister,
              timeRegister: product.timeRegister,
              subTotal: product.subTotal,
              imageURL: product.imageURL,
              discount: product.discounts,
              priceDiscount: discountPrice,
              appointment: product.appointment
            }
          ],
        });
        // Notify cart quantity updated
        this.cartQuantity$.next(this.productsCount);

      } else {
        // Check if the product is already in the cart
         let productIndex = this._cart.products[businessIndex].products.findIndex((productItem: any) => {
            return (
              Number(productItem.id) === Number(product.id) &&
              productItem.dateRegister === product.dateRegister &&
              productItem.timeRegister === product.timeRegister
            );
          });
        if (productIndex === -1) {
          // Add the product
          this._cart.products[businessIndex].products.push({
            id: product.id,
            name: product.name,
            description: product.description,
            comments: product.comments,
            price: product.price,
            quantity: product.quantity,
            dateRegister: product.dateRegister,
            timeRegister: product.timeRegister,
            subTotal: product.subTotal,
            imageURL: product.imageURL,
            discount: product.discounts,
            priceDiscount: discountPrice,
            appointment: product.appointment
          });

          //Add product update shopping cart
          if (this.addProductCart) {
            console.log("Hola 4");
            let body = {
              id: product.id,
              name: product.name,
              description: product.description,
              comments: product.comments,
              price: product.price,
              quantity: product.quantity,
              dateRegister: product.dateRegister,
              timeRegister: product.timeRegister,
              subTotal: product.subTotal,
              imageURL: product.imageURL,
              discount: product.discounts,
              priceDiscount: discountPrice,
              appointment: product.appointment
            };
            this.updateShoppingCart(body, saleAppointment).subscribe((result: any) => {
              console.log('Result update', result.data);
            });
          }

          this.addProductCart = false;

          // Notify cart quantity updated
          this.cartQuantity$.next(this.productsCount);
          // Show cart alert
          this.cartNotification.showCartAlert(this.productsCount, "bottom", businessTheme);
        } else {
          // Update the product
          this._cart.products[businessIndex].products[productIndex].quantity = product.quantity;
          this._cart.products[businessIndex].products[productIndex].subTotal = product.subTotal;

          this.cartQuantity$.next(this.productsCount);
        }
      }
    } else {
        let businessIndex = this._cart.products.findIndex(
          (b: any) => b.id === product.businessId
        );

        const productData = {
          id: product.id,
          name: product.name,
          description: product.description,
          comments: product.comments,
          price: product.price,
          quantity: product.quantity,
          dateRegister: product.dateRegister,
          timeRegister: product.timeRegister,
          subTotal: product.subTotal,
          imageURL: product.imageURL,
          discount: product.discounts,
          priceDiscount: discountPrice,
          appointment: product.appointment
        };

        if (businessIndex === -1) {
          // Empresa no existe → agregarla con el producto
          this._cart.products.push({
            id: product.businessId,
            name: product.businessName,
            ownerId: product.ownerId,
            cartoptions: await this.setCartOptionsValue(product.businessId),
            products: [productData]
          });

          this.cartQuantity$.next(this.productsCount);
          this.cartNotification.showCartAlert(this.productsCount, "bottom", businessTheme);

          // Guardar carrito (solo si es el primero)
          if (this.resultShoppingCart.length === 0) {
            console.log('Entro cuando resultShoppingCart no tiene datos');

            let body = {
              id: product.businessId,
              name: product.businessName,
              ownerId: product.ownerId,
              products: [productData]
            };

            let customerId = this.authService.uid;
            if (await this.authService.getGuestFlag()) {
              customerId = await this.authService.getGuestUuid();
            }

            this.saveShoppingCart(body, customerId, this.cartBusinessPraga$.getValue(), saleAppointment)
              .subscribe((result: any) => {
                console.log('Result save', result.data);
                this.resultShoppingCart = result.data;
                this.shoppingCartId = result.data.id;
              });
          }
        } else {
          // Empresa ya existe → buscar producto
          let productIndex = this._cart.products[businessIndex].products.findIndex((p: any) => {
            return p.id === product.id &&
                  p.dateRegister === product.dateRegister &&
                  p.timeRegister === product.timeRegister;
          });

          if (productIndex === -1) {
            // Producto no existe → agregarlo
            this._cart.products[businessIndex].products.push(productData);
            this.cartQuantity$.next(this.productsCount);
            this.cartNotification.showCartAlert(this.productsCount, "bottom", businessTheme);

            // Actualizar carrito en backend
            this.updateShoppingCart(productData, saleAppointment)
              .subscribe((result: any) => {
                console.log('Result update', result.data);
              });
          } else {
            // Producto ya existe → actualizar cantidad y subtotal
            this._cart.products[businessIndex].products[productIndex].quantity = product.quantity;
            this._cart.products[businessIndex].products[productIndex].subTotal = product.subTotal;
          }
        }

    }
  }

  calculateDiscount(type: string, value: string, price: string, quantity: any) {
    if (type === 'percent') {
      let discountNumb = (100 - Number(value)) / 100;
      return Number(price) * discountNumb;
    }
    if (type === 'amount') {
      let disc = Number(value) * quantity;
      return Number(price) - disc;
    }
    if (type === 'product') {
      let promo;
      if (quantity % 2 === 0) {
        promo = Number(price) / Number(value);
      } else {
        promo = Number(price);
      }
      return promo;
    }
    return '';
  }

  setCartOptionsValue(bussinessId: any): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.getCartOptions(bussinessId).subscribe({
        next: (resp: any) => {
          if (resp.data && resp.data.cartoptions) {
            resolve(resp.data.cartoptions);
          } else {
            resolve(false);
          }
        }, error: (err) => {
          resolve(false);
        }
      });
    })
  }

  getCartOptions(bussinessId: any): Observable<any> {
    return this.httpService.get(this.endpoints.bussinesOptions.replace('{businessId}', bussinessId));
  }

  saveShoppingCart(product: any, customerId: string, businesspraga: any, appointment?: any): Observable<any> {
    let body: any;
    body = {
      businessId: product.id,
      businessname: product.name,
      ownerId: product.ownerId,
      customerId: customerId,
      businesspraga: businesspraga,
      servicesProducts: [
        {
          id: product.products[0].id,
          name: product.products[0].name,
          description: product.products[0].description,
          comments: product.products[0].comments,
          price: product.products[0].price,
          quantity: product.products[0].quantity,
          dateRegister: product.products[0].dateRegister,
          timeRegister: product.products[0].timeRegister,
          subTotal: product.products[0].subTotal,
          imageURL: product.products[0].imageURL,
          discount: product.products[0].discount,
          priceDiscount: product.products[0].priceDiscount,
          appointment: appointment
        }
      ]
    };
    return this.httpService.post(this.endpoints.saveShoppingCart, body);
  }

  //aquiiiiiii............. revisarlo
  updateShoppingCart(product: any, appointment?: any): Observable<any> {
    //sin cita
    let body = {};
    body = {
      id: this.shoppingCartId,
      servicesProducts: [
        {
          id: product.id,
          name: product.name,
          description: product.description,
          comments: product.comments,
          price: product.price,
          quantity: product.quantity,
          dateRegister: product.dateRegister,
          timeRegister: product.timeRegister,
          subTotal: product.subTotal,
          imageURL: product.imageURL,
          discount: product.discount,
          priceDiscount: product.priceDiscount,
          appointment: appointment
        }
      ]
    };
    //con cita
    // body = {
    //     id: this.shoppingCartId,
    //     servicesProducts: [
    //         {
    //             id: product.id,
    //             appointment: appointment
    //         }
    //     ]
    // };


    return this.httpService.put(this.endpoints.updateShoppingCart, body);
  }

  deleteAllShoppingCart(id: any): Observable<any> {
    return this.httpService.delete(this.endpoints.deleteAllShoppingCart.replace('{cartId}', id));
  }

  subTotal(businessIndex: number,popUpView:boolean) {
    let subTotal = 0;
    this._cart.products[businessIndex].products.forEach((product: any) => {
      subTotal += product.priceDiscount ? product.priceDiscount : product.subTotal;
    });
    // if(this.business?.wannaGetDelivery && popUpView){
    //   subTotal  += this.business.deliveryprice
    // }
    return subTotal;
  }

  
  subTotalPopUp() {
    let subTotal = 0;
    this._cart.products.forEach((business: any) => {
      business.products.forEach((product: any) => {
        subTotal += product.priceDiscount ? product.priceDiscount : product.subTotal;
      });
    });
    if(this.business?.wannaGetDelivery){
      subTotal  += this.business.deliveryprice
    }
    return subTotal;
  }

  subTotalNoDelivery() {
    let subTotal = 0;
    this._cart.products.forEach((business: any) => {
      business.products.forEach((product: any) => {
        subTotal += product.priceDiscount ? product.priceDiscount : product.subTotal;
      });
    });
    return subTotal;
  }


  total() {
    let total = 0;
    this._cart.products.forEach((business: any) => {
      business.products.forEach((product: any) => {
        total += product.priceDiscount ? product.priceDiscount : product.subTotal;
      });
    });
    if(this.business?.wannaGetDelivery){
      total  += this.business.deliveryprice
    }
    return total;
  }

  lastBusiness(businessIndex: number) {
    return businessIndex === this._cart.products.length - 1;
  }

  dropProduct(businessIndex: number, productIndex: number) {
    this._cart.products[businessIndex].products.splice(productIndex, 1);
    if (this._cart.products[businessIndex].products.length === 0) {
      this._cart.products.splice(businessIndex, 1);
    }
    // Notify cart quantity updated
    this.cartQuantity$.next(this.productsCount);
  }

  quantityIncrement(businessIndex: number, productIndex: number) {
    if (this._cart.products[businessIndex].products[productIndex]?.discount?.type === 'product') {
      this._cart.products[businessIndex].products[productIndex].quantity += Number(this._cart.products[businessIndex].products[productIndex]?.discount?.value);
    } else {
      this._cart.products[businessIndex].products[productIndex].quantity++;
    }
    const quantity = this._cart.products[businessIndex].products[productIndex].quantity;
    const personalizersAmount = this.personalizersService.getPersonalizersTotalAmount(this._cart.products[businessIndex].products[productIndex].id) * quantity;
    const price = this._cart.products[businessIndex].products[productIndex].price;
    this._cart.products[businessIndex].products[productIndex].subTotal = (price * quantity) + personalizersAmount;
    //discount
    this._cart.products[businessIndex].products[productIndex].priceDiscount =
      this.calculateDiscount(this._cart.products[businessIndex].products[productIndex].discount.type,
        this._cart.products[businessIndex].products[productIndex].discount.value,
        String(this._cart.products[businessIndex].products[productIndex].subTotal), quantity);

  }

  quantityDecrement(businessIndex: number, productIndex: number) {
    if (this._cart.products[businessIndex].products[productIndex].quantity > 1) {
      if (this._cart.products[businessIndex].products[productIndex]?.discount?.type === 'product') {
        this._cart.products[businessIndex].products[productIndex].quantity -= Number(this._cart.products[businessIndex].products[productIndex]?.discount?.value);
      } else {
        this._cart.products[businessIndex].products[productIndex].quantity--;
      }
      const quantity = this._cart.products[businessIndex].products[productIndex].quantity;
      const personalizersAmount = this.personalizersService.getPersonalizersTotalAmount(this._cart.products[businessIndex].products[productIndex].id) * quantity;
      const price = this._cart.products[businessIndex].products[productIndex].price;
      this._cart.products[businessIndex].products[productIndex].subTotal = (price * quantity) + personalizersAmount;
      //discount
      this._cart.products[businessIndex].products[productIndex].priceDiscount =
        this.calculateDiscount(this._cart.products[businessIndex].products[productIndex].discount.type,
          this._cart.products[businessIndex].products[productIndex].discount.value,
          String(this._cart.products[businessIndex].products[productIndex].subTotal), quantity);

    }
  }

  deleteProductCart(id: any): Observable<any> {
    let body = {
      id: this.shoppingCartId,
      servicesProducts: [
        {
          id: id,
        }
      ]
    };
    return this.httpService.put(this.endpoints.updateShoppingCart, body);
  }

  changeAppointmentDateAndTime(businessIndex: number, productIndex: number, date: string, time: string, appointment: any) {
    this._cart.products[businessIndex].products[productIndex].dateRegister = date;
    this._cart.products[businessIndex].products[productIndex].timeRegister = time;

    this.updateShoppingCart(this._cart.products[businessIndex].products[productIndex], appointment).subscribe((result: any) => {
      console.log('Result update', result.data);
    });
  }

  updateCustomerComments(): Observable<any> {
    let body = {
      id: this.shoppingCartId,
      customercomments: this.customerComments$.getValue(),
      servicesProducts: (this._cart.products[0].products) ? this._cart.products[0].products : []
    };

    return this.httpService.put(this.endpoints.updateShoppingCart, body);
  }

  async transferGuestCartToUser(userId: string, guestId: String, cartId: any) {
    const body = {
      guestId: guestId,
      loginId: userId,
      cartId: cartId
    };

    return this.httpService.put(this.endpoints.shoppingCartForGuestCustomer, body);
  }

}
